// Persian digits in numeric fields (F115): whatever the user types —
// Persian, Arabic or Latin digits — is kept as Latin digits for the API and
// shown back in Persian.

const FA = "۰۱۲۳۴۵۶۷۸۹";
const AR = "٠١٢٣٤٥٦٧٨٩";

export function toLatinDigits(s: string): string {
  return s.replace(/[۰-۹٠-٩]/g, (d) => String(FA.includes(d) ? FA.indexOf(d) : AR.indexOf(d)));
}

export function toFaDigits(s: string | number): string {
  return String(s).replace(/\d/g, (d) => FA[Number(d)]!);
}

/** Only the digits of what was typed, as Latin, at most `max`. */
export function onlyDigits(s: string, max?: number): string {
  const d = toLatinDigits(s).replace(/\D/g, "");
  return max ? d.slice(0, max) : d;
}

/** A stored mobile ("+989121234567") as people write it: "۰۹۱۲۱۲۳۴۵۶۷" (11 digits). */
export function displayPhone(phone: string): string {
  return toFaDigits(phone.replace(/^\+98/, "0"));
}

/**
 * A landline as people write it, area code first: "02192001114" →
 * "۰۲۱-۹۲۰۰۱۱۱۴". Anything else (a mobile, an odd format) is shown as typed.
 */
export function displayLandline(phone: string): string {
  const d = onlyDigits(phone);
  return toFaDigits(/^0[1-8]\d{9}$/.test(d) ? `${d.slice(0, 3)}-${d.slice(3)}` : phone);
}

/**
 * A masked card number, as "۶۰۳۷ ۹۹** **** ۷۸۹۳", from either form api sends
 * ("6037 99•• •••• 7893" or the bank's "603799******7893"). Hidden digits are
 * stars: a dot would read as the Persian zero (۰).
 */
export function maskedCard(masked: string): string {
  const chars = masked.replace(/[•·]/g, "*").replace(/[^\d*]/g, "");
  return toFaDigits(chars.replace(/(.{4})(?=.)/g, "$1 "));
}
